<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(params.FormId)" />
      <!-- <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(params.id)" /> -->
    </div>
</template>

<script>
export default {
  name: 'CellRendererRegFormActions',
  methods: {
    editRecord (id) {
      //console.log(id);
      //id = window.btoa(id);
      this.$router.push({ 
        name: 'regform-edit', 
        params: {
                  FormId: id
                } 
      }).catch(() => {})

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      //this.showDeleteSuccess()
      this.$vs.loading();
      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch("attendeeManagement/removeRecord", this.params.id)
        .then((res)   => { 
          this.$vs.loading.close();
          if(res.status == 200) 
          {
            this.$store.dispatch('attendeeManagement/fetchAttendees');   
            this.showDeleteSuccess() 
          }
        })
        .catch(err => { 
          console.error(err)       
          this.$vs.loading.close();
        })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Record Deleted',
        text: 'The selected record was successfully deleted'
      })
    }
  }
}
</script>
